'use client';

import React from 'react';

import { animated, useSpring } from '@react-spring/web';

interface SearchAndFindGameCardProps {
  use: string;
  rotate: number;
  tileIndex: number;
  tileCount: number;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  isIncorrectGuess: boolean;
  isCorrectGuess: boolean;
  isGameOver: boolean;
}

export function SearchAndFindGameCard({
  use,
  onClick,
  rotate,
  tileIndex,
  tileCount,
  isIncorrectGuess,
  isCorrectGuess,
  isGameOver,
}: SearchAndFindGameCardProps) {
  const [svgStyles, svgApi] = useSpring(() => ({
    transform: `scale(1.125) translate(0, -5%) rotate(${rotate}deg)`,
    opacity: 0,
  }));

  const isInteractive = !isIncorrectGuess && !isCorrectGuess && !isGameOver;

  React.useEffect(() => {
    const ms = 100 * Math.floor(Math.random() * (5 - 1 + 1) + 1);
    svgApi.start({ opacity: 1, transform: `scale(1) translate(0px, 0px) rotate(${rotate}deg)`, delay: ms });
  }, [rotate, svgApi]);

  React.useEffect(() => {
    if (isIncorrectGuess) {
      svgApi.start({ opacity: 0.5, transform: `scale(0.875)  translate(0px, 0px) rotate(${rotate}deg)` });
    }
    if (isGameOver && !isCorrectGuess) {
      svgApi.start({ opacity: 0.5 });
    }
  }, [isIncorrectGuess, isCorrectGuess, isGameOver, rotate, svgApi]);

  return (
    <animated.button
      type='button'
      aria-label={`Select item ${tileIndex + 1} of ${tileCount}`}
      className='h-24 w-24 border-0 bg-transparent p-0'
      disabled={!isInteractive}
      onClick={onClick}
      onMouseEnter={() => {
        if (isInteractive) {
          svgApi.start({ transform: `scale(1.125) translate(0px, 0px) rotate(${rotate}deg)` });
        }
      }}
      onMouseLeave={() => {
        if (isInteractive) {
          svgApi.start({ transform: `scale(1) translate(0px, 0px) rotate(${rotate}deg)` });
        }
      }}
      style={{
        transformOrigin: '50% 50%',
        cursor: isInteractive ? 'pointer' : 'default',
        ...svgStyles,
      }}
    >
      <svg aria-hidden='true' className='h-full w-full' fill='none' focusable='false' xmlns='http://www.w3.org/2000/svg'>
        <use xlinkHref={`#${use}`} />
      </svg>
    </animated.button>
  );
}
